
import base_url from './base_url';

const Reservation = (function () {
  const day = {
    1800: 0,
    1815: 0,
    1830: 0,
    1845: 0,
    1900: 0,
    1915: 0,
    1930: 0,
    1945: 0,
    2000: 0,
    2015: 0,
    2030: 0,
    2045: 0,
    2100: 0,
    2115: 0,
    2130: 0,
    2145: 0,
    2200: 0,
    2215: 0,
    2230: 0,
    2245: 0,
    2300: 0,
    2315: 0,
    2330: 0,
    2345: 0,
  }
  let state = {
    lang: null,
    time: null,
    day: null,
    ready: false,
    loading: false
  }

  let texts = {
    afterfive: {
      en: "We can not take online reservations for today after 5pm, please call us!",
      hu: "A mai napra 17h után már csak telefonon lehet foglalni!"
    },
    monday: {
      en: "On Mondays we have to rest a bit, so we are closed!<br>Please try to come another day!",
      hu: "Hétfőn zárva vagyunk!<br>Kérjük válassz másik napot!"
    },
    fullHouse: {
      en: "We are full for the day, please call or select another day!",
      hu: "A mai napra már tele vagyunk, kérjük telefonon érdeklődj!"
    }
  }

  let special_dates = [
    '12-31'
  ]

  function _loader(what) {
    if (what === 'on') {
      $('body').addClass('loading');
    } else {
      $('body').removeClass('loading');
    }
  }

  function _setupView() {
    
    let dt = new Date();
    let day = dt.getDay();
    if (day === 1) { dt.setDate(dt.getDate() + 1) }
    console.log(state)
    console.log(day)
    $('.res-header-title').addClass(state.lang);
    $('.lang').addClass(state.lang);
    $('.reservation').addClass(state.lang)
    $(function () {
      $("#date").datepicker({
        altFormat: "yy-mm-dd",
        dateFormat: "yy-mm-dd",
        minDate: dt,
        defaultDate: 0,
        firstDay: 1,
        beforeShowDay:
          function (dt) {
            console.log(dt.getMonth() + ' ' + dt.getDate());
            let fd = (dt.getMonth() + 1) + '-' + dt.getDate();
            let ok = false;
            if (special_dates.includes(fd)) {
              ok = true;
            } else if (dt.getDay() !== 1) {
              ok = true;
            }
            return [ok];
          }
      });
    });
    var d = new Date();
    var n = d.toISOString();
    $('#date').val(n.split('T')[0])

    $('#date').on('change', function () {
      console.log($(this).val())
      let date = $(this).val();

      state.selectedDate = date.split('-').join('');
      let dd = new Date(date)
      let daynum = dd.getDay();
      if (daynum === 1) {
        state.day = 'Monday';
      } else {
        state.day = 'not monday';
      }
      console.log(state.day)

      console.log(state.selectedDate)
      _checkDay();
    })
  }

  function _setupListeners() {
    $("[type='submit']").click(function () {
      _submit();
    })

    $('[name=person]').on('change', function () {
      let person = $(this).val();
      if (person > 9) {
        $('.info-modal-inner').addClass('open');
      }
    })

    $('.info-modal-inner span').click(function () {
      $('.info-modal-inner').removeClass('open');
    })

    $('.lang').on('click', function () {
      state.lang = state.lang === 'hu' ? 'en' : 'hu';
      $('.reservation').removeClass('hu').removeClass('en').addClass(state.lang);
      $('.lang').removeClass('hu').removeClass('en').addClass(state.lang);
      $('.res-header-title').removeClass('hu').removeClass('en').addClass(state.lang);
    })

    $('[name=date]').on('change', function() {
      let selectedDate = $(this).val().split('-').join('');
      state.selectedDate = selectedDate;
      _checkDay();
    })
  }

  function _calculateStay(res, stay) {
    let times = Object.keys(day);
    let time = res.startHour + "" + res.startMin;
    let index = times.findIndex(t => time === t);
    let s = parseFloat(stay) * 4;
    let end = times[index + s] ? times[index + s] : "2345";
    return end;
  }

  function _submit() {
    let reservation = {};
    reservation['date'] = $('[name=date]').val().split('-').join('');
    reservation['name'] = $('[name=name]').val();
    reservation['email'] = $('[name=email]').val();
    reservation['startMin'] = $('[name=startMin]').val();
    reservation['startHour'] = $('[name=startHour]').val();
    let end = _calculateStay(reservation, $('[name=stay]').val())
    reservation['endHour'] = end.substring(0, 2);
    reservation['endMin'] = end.substring(2);
    reservation['person'] = $('[name=person]').val();
    reservation['note'] = $('[name=note]').val();
    reservation['phone'] = $('[name=phone_code]').val() + $('[name=phone]').val();
    reservation['lang'] = state.lang;
    console.log(reservation)
    if (!reservation.name || !reservation.email) {
      window.alert('Hiányzó adatok! / Missing fields!');
    } else {
      if (!state.loading) {
        $(".btn").addClass('faded');
        state.loading = true;
        
        $.ajax({
          url: base_url + '/m_2/api/reservation',
          method: 'POST',
          data: reservation,
          success: function(response) {
            state.loading = false;
            console.log(response)
            window.location.href = base_url + '/m_2/finish/#/' + state.lang
          },
          error: function(error) {
            $(".btn").removeClass('faded');
            state.loading = false;
            console.log(error)
          }
        })
      }
    }
  }

  function _getTime(callback) {
    $.ajax({
      url: base_url + '/m_2/api/time',
      method: 'GET',
      success: function (response) {
        response = JSON.parse(response);
        console.log(response);
        
        state.time = response.hour;
        state.day = state.day ? state.day : response.dayname;
        state.date = response.year + '' + (('' + response.month).length === 1 ? '0' + response.month : response.month) + '' + (('' + response.date).length === 1 ? '0' + response.date : response.date);
        state.selectedDate = $('[name=date]').val().split('-').join('');
       /*
        state['date'] = "20180602";
        state['day'] = "not monday";
        state.selectedDate = state.selectedDate ? state.selectedDate : state.date;
        state['time'] = 15;*/
        callback();
      },
      error: function (error) {
        console.log(error)
      }

    })
  }

  function _getDayData(callback) {
    $.ajax({
      url: base_url + '/m_2/api/reservation/get_public_date?date=' + state.selectedDate,
      method: 'GET',
      success: function (response) {
        response = JSON.parse(response);
        console.log(state.date)
        console.log(response);
        callback(response);
      },
      error: function (error) {
        console.log(error)
      }

    })
  }

  function _checkDay() {
    state.ready = false;
    _loader('on');
    _getTime(() => {
      if (true /*(state.selectedDate === state.date && state.time < 17) || (state.selectedDate !== state.date)*/) {
        console.log(state)
        let dddd = $('[name=date]').val().split('-');
        let dd = dddd[1] + '-' + dddd[2];
        let special = special_dates.includes(dd);
        let ok = false;
        if (state.day == 'Monday' && special) {
          ok = true;
        } else if (state.day !== 'Monday') {
          ok = true;
        }
        if (ok) {
          console.log(state.day);
          _getDayData((result) => {
            if (result && result.holiday) {
              $(`.alert-inner .hu`).html(result.holiday['hun']);
              $(`.alert-inner .en`).html(result.holiday['eng']);
              $('.alert-inner').addClass('open')
              $('.res-body').addClass("disabled")
              _loader('off');
            } else if (state.selectedDate === state.date && state.time >= 17) { 
              $(`.alert-inner .hu`).html(texts.afterfive['hu']);
              $(`.alert-inner .en`).html(texts.afterfive['en']);
              $('.alert-inner').addClass('open')
              $('.res-body').addClass("disabled")
              _loader('off');
            } else if (result && result.fullHouse) {
              $(`.alert-inner .hu`).html(texts.fullHouse['hu']);
              $(`.alert-inner .en`).html(texts.fullHouse['en']);
              $('.alert-inner').addClass('open')
              $('.res-body').addClass("disabled")
              _loader('off');
            } else {
              // everything is ok
              _loader('off');
              state.ready = true;
              $('.alert-inner').removeClass('open')
              $('.res-body').removeClass("disabled")
            }
          }); // check firebase
        } else {
          console.log(texts.monday[state.lang])
          console.log(state.lang)
          $(`.alert-inner .hu`).html(texts.monday['hu']);
          $(`.alert-inner .en`).html(texts.monday['en']);
          $('.alert-inner').addClass('open')
          $('.res-body').addClass("disabled")
          _loader('off');
          state.ready = true;
        }
      } else {
        if (state.day === 'Monday') {
          console.log(texts.monday[state.lang])
          console.log(state.lang)
          $(`.alert-inner .hu`).html(texts.monday['hu']);
          $(`.alert-inner .en`).html(texts.monday['en']);
          $('.alert-inner').addClass('open')
          $('.res-body').addClass("disabled")
        } else {
          $(`.alert-inner .hu`).html(texts.afterfive['hu']);
          $(`.alert-inner .en`).html(texts.afterfive['en']);
          $('.alert-inner').addClass('open')
          $('.res-body').addClass("disabled")
        }
        _loader('off');
        state.ready = true;
      }
    }); // check time / check if monday
  }

  return {
    init: () => {
      console.log(window.location.hash)
      state.lang = window.location.hash.split('/')[1];
      _setupView();
      _checkDay();
      _setupListeners();
    }
  }
})();

export default Reservation;


// WEBPACK FOOTER //
// ./src/Reservation.js